export default function () {
	"ngInject";
	return {
		require: 'ngModel',
		restrict: 'A',
		link: function (scope, elem, attr, ngModel) {

			ngModel.$validators.shotValidator = function (modelValue, viewValue) {
				if (!viewValue) {
					return true;
				}

				if(viewValue >= 0 && viewValue <= 11){ return true; }
				if(viewValue.toLowerCase() === "m" || viewValue.toLowerCase() === "x"){ return true; }

				return false;
			};
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/common/directives/shotValidator.directive.js